import Autorizacao from "@/Models/Autorizacao";
import Axios from "@/plugins/Axios";
import store from "@/store";

export class AutorizacoesService {
  async verificarPedidosDeferidos(etapa, tipo = "aula", instrutorDisciplinaTurmaId = null) {
    const currentUser = store.getters["Auth/user"];
    let url = `verificar-pedidos-deferidos?user_id=${currentUser.id}&etapa_id=${etapa}&tipo=${tipo}`;
    if (instrutorDisciplinaTurmaId) {
      url += `&instrutorDisciplinaTurma_id=${instrutorDisciplinaTurmaId}`;
    }
    const response = await Axios().get(url);
    return response;
  }

  async getUsuarios(pageNumber, query = "") {
    const currentUser = store.getters["Auth/user"];
    const response = await Axios().get(
      `get-usuarios-autorizacao?configuracao_id=${currentUser.configuracao_id}`
    );
    // const usuarios = response.data.data.map((usuario) => new Usuario(usuario));
    return response;
  }

  async syncAll(tipo) {
    const currentUser = store.getters["Auth/user"];
    let url = "autorizacoes";

    if (tipo === "solicitante") {
      url = `autorizacoes?userSolicitante=${currentUser.id}`;
    }
    if (tipo === "aprovador") {
      url = `autorizacoes?userAprovador=${currentUser.id}`;
    }

    const response = await Axios().get(url);
    const etapas = response.data.map((etapa) => new Autorizacao(etapa));
    // store.commit("Autorizacoes/setAutorizacoes", etapas);
    return etapas;
  }

  async criarAutorizacao(etapa) {
    const response = await Axios().post("autorizacoes", etapa);
    const novoEtapa = response.data;
    store.commit("Autorizacoes/adicionarAutorizacao", novoEtapa);
    return novoEtapa;
  }

  async atualizarAutorizacao(circuito) {
    const response = await Axios().put(`autorizacoes/${circuito.id}`, circuito);
    const etapa = response.data;
    store.commit("Autorizacoes/atualizarAutorizacao", etapa);
    return etapa;
  }

  async atualizarSituacao(autorizacao, novaSituacao) {
    const response = await Axios().put(`autorizacoes/${autorizacao.id}`, {
      ...autorizacao,
      status: novaSituacao,
    });
    const autAtualizada = response.data;
    return new Autorizacao(autAtualizada);
  }

  async deletarEtapa(circuito) {
    const response = await Axios().delete(`autorizacoes/${circuito.id}`);
    const etapaDeletada = response.data;
    store.commit("Autorizacoes/deletarAutorizacao", circuito.id);
    return etapaDeletada;
  }
}
export default new AutorizacoesService();
